angular.module('bmsApp.crm.enquiry')
	.controller('EnquirySaveCtrl', function ($state,
											 $scope,
											 $q,
											 notify,
											 EnquirySourceSvc,
											 EnquiryStatusSvc,
											 MMEnquiryRejectedReasonSvc,
											 MMEnquiryCleanTypeSvc,
											 SMScheduleSvc,
											 FormOptionsSvc,
											 ContactDetailTypeSvc,
											 QuoteStatusSvc,
											 EmployeeSvc,
											 SMEnquiryRejectedReasonSvc,
											 SMHouseTemplateSvc,
											 SMCleaningServiceSvc,
											 LicenseOptionsSvc,
											 EnquirySvc,
											 TaxHelperSvc,
											 SiteSvc,
											 CustomerSvc,
											 ProximitySvc,
											 ) {

		$scope.init = function () {
			$scope.noteCtrl = {
				note: {},
				noteApi: {}
			};
			$scope.activityCtrl = {
				activity: {},
				activityApi: {}
			};
			$scope.enqiury = {
				proforma: {
					cleaning_services: []
				}
			};
			// updating or creating/converting
			$scope.updating = $state.current.name == 'main.crm.enquiry.index.view.update';
			$scope.converting = $state.current.name == 'main.crm.enquiry.index.view.convert';
			// blank enquiry
			$scope.enquiry = {
				status: {
					id: 1 // defaults to 'New'
				}
			};
			$scope.loading = true;
			$scope.processing = false;
			// options promises for selects / checklists
			var promises = {
				statusOptions: EnquiryStatusSvc.options(),
				titleOptions: FormOptionsSvc.title(),
				contactDetailTypeOptions: ContactDetailTypeSvc.options(),
				licenseOptions: LicenseOptionsSvc.license(),
				vatRate: TaxHelperSvc.setVatRate()
			};
			if ($scope.isMM()) {
				promises.mmEnquiryRejectedReasonOptions = MMEnquiryRejectedReasonSvc.options();
				promises.mmEnquiryCleanTypeOptions = MMEnquiryCleanTypeSvc.options();
			}
			if ($scope.isSM()) {
				promises.enquirySourceOptions = EnquirySourceSvc.options()
					.then(function (response) {
						$scope.sourceOptions = response.data.options;
					});
				promises.smEnquiryRejectedReasonOptions = SMEnquiryRejectedReasonSvc.options()
					.then(function (response) {
						$scope.smEnquiryRejectedReasonOptions = response.data.options;
					});
				promises.quoteStatusOptions = QuoteStatusSvc.options();
				promises.employeeOptions = EmployeeSvc.index({
					filter: {
						status: true
					}
				})
			}
			if ($scope.updating) {
				promises.enquiry = EnquirySvc.read($state.params.enquiryId);

			}
			$q.all(promises)
				.then(function (responses) {
					$scope.statusOptions = responses.statusOptions.data.options;
					$scope.titleOptions = responses.titleOptions.data.options;
					$scope.contactDetailTypeOptions = responses.contactDetailTypeOptions.data.options;
					$scope.licenseOptions = responses.licenseOptions.data.options;
					if ($scope.licenseOptions.length === 1) {
						angular.extend($scope.enquiry, {
							license: $scope.licenseOptions[0],
						});
					}
					if (responses.mmEnquiryRejectedReasonOptions || promises.mmEnquiryCleanTypeOptions) {
						$scope.mmEnquiryRejectedReasonOptions = responses.mmEnquiryRejectedReasonOptions.data.options;
						$scope.mmEnquiryCleanTypeOptions = responses.mmEnquiryCleanTypeOptions.data.options;
					}
					if (responses.quoteStatusOptions) {
						$scope.quoteStatusOptions = responses.quoteStatusOptions.data.options;
						$scope.employeeOptions = responses.employeeOptions.data.employee_collection;
					}
					if (responses.enquiry) {
						angular.extend($scope.enquiry, responses.enquiry.data.enquiry);
					}
					if (angular.isObject($scope.enquiry.sm_proforma_quote)) {
						$scope.enquiry.smProformaExists = true;
					}
					else {
						angular.extend($scope.enquiry ,{sm_proforma_quote: {}});
					}

					if (!$scope.updating) {
						$scope.enquiry.sales_pipeline = {
							'probability': 0,
							'annual_forecast': 0
						};
					}
					else {
						$scope.checkPostcode();
					}

					$scope.loading = false;
				});
		};

		$scope.updateQuoteName = function() {
			if ($scope.enquiry.smProformaExists) {
				var lastName = $scope.enquiry.last_name;
				if (angular.isString(lastName)) {
					lastName = lastName.toUpperCase();
				}
				if (angular.isUndefined($scope.enquiry.sm_proforma_quote)) {
					angular.extend($scope.enquiry, {
						sm_proforma_quote: {
							quote_name: ''
						}
					});
				}

				var lastName = (lastName || '');
				if (lastName) {
					lastName += '-';
				}
				$scope.enquiry.sm_proforma_quote.quote_name = lastName + moment()
						.format('MMM-D-YYYY')
						.toUpperCase();

			}
		};

		$scope.smProformaClicked = function () {
			if ($scope.enquiry.smProformaExists) {
				$scope.updateQuoteName();
				$scope.enquiry.sm_proforma_quote.quote_status = {
					id: 1
				};
			}
			else {
				$scope.enquiry.sm_proforma_quote.quote_name = '';
			}

		};

		$scope.showProximityLocatorModal = function(){
			var hours = $scope.enquiry.sm_proforma_quote.hours || 0;
			var mins = $scope.enquiry.sm_proforma_quote.minutes || 0;
			$scope.enquiry.sm_proforma_quote.duration_in_mins = (parseFloat(hours) * 60) + parseFloat(mins);
			ProximitySvc.showLocatorModal($scope.enquiry.license, $scope.enquiry.postcode, $scope.enquiry.sm_proforma_quote.duration_in_mins)
				.then(function (result) {
					$scope.enquiry.sm_proforma_quote.visits = [];
					$scope.enquiry.sm_proforma_quote.visits.push({
						employees: [
							result.employee
						],
						hours: $scope.enquiry.sm_proforma_quote.hours,
						minutes: $scope.enquiry.sm_proforma_quote.minutes,
						visit_date: result.dateTime,
						visit_time: result.dateTime
					});
				});
		}

		$scope.addressLookup = function() {
			return SiteSvc.lookup({postcode: $scope.enquiry.postcode_lookup, houseNo: $scope.enquiry.houseno_lookup}).then(function(response) {
				$scope.addressList = response.data.addresses;
				if ($scope.addressList.length === 1) {
					let address = $scope.addressList[0];
					$scope.enquiry.address_line_1 = address.line_1 || '';
					$scope.enquiry.address_line_2 = address.line_2 || '';
					$scope.enquiry.address_line_3 = address.line_3 || '';
					$scope.enquiry.city = address.city || '';
					$scope.enquiry.county = address.county || '';
					$scope.enquiry.postcode = address.postcode || '';
					$scope.enquiry.showLookup = false;
					$scope.checkPostcode();
				}
			}, function() {
				notify({
					message: 'Address not found',
					classes: 'error',
				});
			});
		};

		$scope.addressChanged = function(address) {
			$scope.enquiry.address_line_1 = address.line_1;
			$scope.enquiry.address_line_2 = address.line_2;
			$scope.enquiry.address_line_3 = address.line_3;
			$scope.enquiry.city = address.city;
			$scope.enquiry.county = address.county;
			$scope.enquiry.postcode = address.postcode;
			$scope.enquiry.showLookup = false;
			$scope.checkPostcode();
			$scope.checkPostcode();
		};

		$scope.formvalidatorconfig = {
			submitHandler: function (form) {
				// join the note to the enquiry if it was filled in
				if (angular.isObject($scope.noteCtrl.noteApi) && $scope.noteCtrl.noteApi.isNoteFilled() === true) {
					if (!$scope.noteCtrl.noteApi.submittable) {
						return;
					}
					angular.extend($scope.enquiry, {
						note: angular.copy($scope.noteCtrl.note)
					});
				}

				// join the activity to the enquiry if it was filled in
				if (angular.isObject($scope.activityCtrl.activityApi) && $scope.activityCtrl.activityApi.isActivityFilled() === true) {
					angular.extend($scope.enquiry, {
						activity: angular.extend({}, $scope.activityCtrl.activity, {
							activity_start_date: $scope.activityCtrl.activity.activity_start_date.format('YYYY-MM-DD HH:mm:ss'),
							activity_end_date: $scope.activityCtrl.activity.activity_end_date.format('YYYY-MM-DD HH:mm:ss')
						})
					});
				}
				$scope.processing = true;

				if ($scope.enquiry.smProformaExists) {
					var hours = $scope.enquiry.sm_proforma_quote.hours || 0;
					var mins = $scope.enquiry.sm_proforma_quote.minutes || 0;
					$scope.enquiry.sm_proforma_quote.duration_in_mins = (parseFloat(hours) * 60) + parseFloat(mins);

					// combine the date/time columns
					if (angular.isArray($scope.enquiry.sm_proforma_quote.visits)) {
						angular.forEach($scope.enquiry.sm_proforma_quote.visits, function(visit) {
							angular.extend(visit, {
								visit_date: moment(visit.visit_date).format('YYYY-MM-DD') + ' ' + visit.visit_time.format('HH:mm')
							});
						});
					}
				}
				else {
					delete $scope.enquiry.sm_proforma_quote;
				}

				var savePromise = $scope.updating ? EnquirySvc.update($scope.enquiry.id, $scope.enquiry) : EnquirySvc.create($scope.enquiry);
				savePromise
					.then(function (response) {
						$scope.enquiry = response.data.enquiry;
						if (angular.isDefined(response.data.smProformaConverted)) {
							notify({
								message: $scope.updating ? 'Enquiry updated' : 'Enquiry converted and job created'
							});

							$state.go('main.sm.job.index.view', {jobId: response.data.smJobId});
						}
						else {
							notify({
								message: $scope.updating ? 'Enquiry updated successfully' : 'Enquiry created successfully'
							});
							$state.go('main.crm.enquiry.index.view', {
								enquiryId: $scope.enquiry.id
							});
						}


					}, function (error) {
						$scope.errors = error;
					})
					.finally(function () {
						$scope.processing = false;
					});
			},
			errorPlacement: function (error, element) {
				error.appendTo('#enquiry-errors');
			},
			errorContainer: '#enquiry-errors'
		};

		$scope.licenseChanged = function() {
			$scope.checkPostcode();
		};

		$scope.checkPostcode = function () {
			$scope.postcodeOutOfArea = false;

			if ($scope.enquiry.license) {
				var promises = {
					geographicRestriction: EnquirySvc.geographicalCheck($scope.enquiry, $scope.enquiry.license)
				};
	
				$q.all(promises).then(function(responses) {
					$scope.postcodeOutOfArea = !responses.geographicRestriction.data.restrictionPassed;
				});
			}
			else {
				var params = {
					postcode: $scope.enquiry.postcode
				};
				EnquirySvc.licenseReverseLookup(params).then(function(response) {
					if (angular.isObject(response.data.license)) {
						$scope.enquiry.license = response.data.license;
					}
				});
			}
		};

		// BMS4 renames the enquiry status value 'rejected' to 'declined' on the shared database;
		// treat both as rejected until every franchisee has left V3.
		$scope.isRejectedStatus = function (status) {
			return angular.isObject(status) && (status.value === 'rejected' || status.value === 'declined');
		};

		$scope.enquirySaveCtrl = {
			showMmEnquiryRejectedReason: function () {
				return $scope.isMM() && $scope.isRejectedStatus($scope.enquiry.status);
			},
			showMmEnquiryRejectedReasonDescription: function () {
				return $scope.enquirySaveCtrl.showMmEnquiryRejectedReason() && angular.isObject($scope.enquiry.mm_enquiry_rejected_reason) && $scope.enquiry.mm_enquiry_rejected_reason.value === 'other';
			},
			showSmEnquiryRejectedReason: function () {
				return $scope.isSM() && $scope.isRejectedStatus($scope.enquiry.status);
			}
		};

		// SM Specific inline code

		$scope.addCleaningService = function () {
			let licenseId = $scope.enquiry.license ? $scope.enquiry.license.id : null;
			SMCleaningServiceSvc.showCleaningServiceModal(null, licenseId)
				.then(function (result) {
					if (!angular.isArray($scope.enquiry.sm_proforma_quote.scheduled_cleaning_services)) {
					// if (!$scope.enquiry.sm_proforma_quote.hasOwnProperty('cleaning_services')) {
						angular.extend($scope.enquiry.sm_proforma_quote, {
							scheduled_cleaning_services: []
						});
					}
					angular.extend(result.cleaningService,{
						accepted: true,
						satisfied: true,
					});

					$scope.enquiry.sm_proforma_quote.scheduled_cleaning_services.push(result.cleaningService);
					calculateEstimatedJobDuration();
				});
		};

		$scope.editCleaningService = function (item) {
			SMCleaningServiceSvc.showCleaningServiceModal(item, $scope.enquiry.license.id)
				.then(function (result) {
					angular.extend(item, result.cleaningService);
				});
		};

		$scope.deleteCleaningService = function (item) {
			if (item.added) {
				$scope.enquiry.sm_proforma_quote.scheduled_cleaning_services.splice($scope.enquiry.sm_proforma_quote.scheduled_cleaning_services.indexOf(item), 1);
			}
			else {
				angular.extend(item, {
					delete: true
				});
			}
			calculateEstimatedJobDuration();
		};

		$scope.undoDeleteCleaningService = function (item) {
			angular.extend(item, {
				delete: false
			});
		};

		$scope.selectTemplate = function () {
			SMHouseTemplateSvc.showSelectTemplateModal()
				.then(function (result) {
					$scope.enquiry.sm_proforma_quote.scheduled_cleaning_services = [];
					$scope.enquiry.sm_proforma_quote.scheduled_cleaning_services = result.houseTemplate.cleaning_services;
					calculateEstimatedJobDuration();
				});
		};

		function calculateEstimatedJobDuration() {
			var totalMins = 0;
			angular.forEach($scope.enquiry.sm_proforma_quote.scheduled_cleaning_services, function (service) {
				if (service.delete !== true) {
					totalMins += parseFloat(service.cleaning_service.duration_in_mins) || 0;
				}
			});
			$scope.enquiry.sm_proforma_quote.estimatedTotalMins = totalMins;
		}

		// visit stuff
		$scope.addVisit = function (defaultMins) {
			if (!angular.isArray($scope.enquiry.sm_proforma_quote.visits)) {
				angular.extend($scope.enquiry.sm_proforma_quote, {
					visits: []
				});
			}
			$scope.enquiry.sm_proforma_quote.visits.push({
				duration_in_mins: (angular.isDefined(defaultMins)) ? defaultMins : 0,
				employees: [
					{}
				]
			});
		};

		$scope.visitEmployeeChanged = function (visit, employee) {
			// Check the visit doesn't already contain this employee
			var alreadyUsedCount = 0;
			angular.forEach(visit.employees, function (existingEmployee) {
				if (existingEmployee.id === employee.id) {
					alreadyUsedCount++;
				}
			});

			if (alreadyUsedCount > 1) {
				employee.id = null;
				$mdDialog.show(
					$mdDialog.alert()
						.clickOutsideToClose(true)
						.title('Can\'t set employee')
						.textContent('This employee is already assigned to the visit')
						.ariaLabel('employee')
						.ok('Okay')
				);
			}
		};

		$scope.showAvailabilityModal = function () {
			SMScheduleSvc.showAvailabilityModal(undefined, getMins(), $scope.enquiry.license, $scope.enquiry.postcode)
				.then(function (result) {
					angular.extend(result.employee, {
						actual: false,
						scheduled: true
					});
					$scope.enquiry.sm_proforma_quote.visits = [];
					angular.extend($scope.enquiry.sm_proforma_quote, {
						visits: [
							{
								employees: [
									result.employee
								],
								hours: $scope.enquiry.sm_proforma_quote.hours,
								minutes: $scope.enquiry.sm_proforma_quote.minutes,
								visit_date: result.dateTime,
								visit_time: result.dateTime

							}
						]
					});
					// ensure duration_in_mins gets updated
					$scope.minutesUpdated($scope.enquiry.sm_proforma_quote.visits[0]);
				});
		};

		function getMins() {
			var hours = $scope.enquiry.sm_proforma_quote.hours || 0;
			var mins = $scope.enquiry.sm_proforma_quote.minutes || 0;
			return (parseFloat(hours) * 60) + parseFloat(mins);
		}

		// ------------------------------- VisitList Directives Callbacks ----------------------------
		$scope.minutesUpdated = function (visit) {
			if (visit) {
				var hours = visit.hours || 0;
				var mins = visit.minutes || 0;
				visit.duration_in_mins = (parseFloat(hours) * 60) + parseFloat(mins);
			}

			var totalMinutes = $scope.enquiry.sm_proforma_quote.duration_in_mins;
			var totalAllocated = 0;
			angular.forEach($scope.enquiry.sm_proforma_quote.visits, function (visit) {
				if (angular.isNumber(parseFloat(visit.duration_in_mins))) {
					totalAllocated += parseFloat(visit.duration_in_mins);
				}
			});

			$scope.enquiry.sm_proforma_quote.totalAllocatedMins = totalAllocated;
			$scope.enquiry.sm_proforma_quote.totalRemainingAllocated = totalMinutes - totalAllocated;

		};

		$scope.removeVisitAtIndex = function (index) {
			$scope.enquiry.sm_proforma_quote.visits.splice(index, 1);
		};

		$scope.init();

	});
